export default __webpack_public_path__ + "static/media/close.441aff21.svg";